import {useService} from "../../../../../../base/hooks/useService";
import ToasterService from "../../../../../../services/ToastService";
import {useLoading} from "../../../../../../base/hooks/useLoading";
import {useModal} from "../../../../../../base/hooks/useModal";
import AdminsService from "../../../../../../services/AdminsService";
import {KEY_USER} from "../../../../../../base/constants/storage";
import StorageService from "../../../../../../services/StorageService";
import React, {useEffect, useState} from "react";
import {initialValues, validationSchema} from "./form";
import joinClassNames from "../../../../../../base/helpers/joinClassNames";
import FormikInput from "../../../../../../base/components/FormikInput";
import Button from "../../../../../../base/components/Button";
import {BUTTON_COLORS} from "../../../../../../base/components/Button/appearance";
import {MAX_NAME_LENGTH} from "../../../../../../validation/lengthConstants";
import {Formik} from "formik";
import {ModalFooter} from "reactstrap";
import FormikReactSelect from "../../../../../../base/components/FormikReactSelect";

const InviteAdminModal = ({isOpen, onClose, afterInvite, admin, isEdit = false}) => {
    /**
     * @type {AdminsService}
     */
    const adminsService = useService(AdminsService);
    /**
     * @type {ToasterService}
     */
    const toastService = useService(ToasterService);
    /**
     * @type {StorageService}
     */
    const storage = useService(StorageService);

    const DEFAULT_OPTIMALLY_ME_ORG = 1;
    const {organisationId} = storage.get(KEY_USER, {organisationId: DEFAULT_OPTIMALLY_ME_ORG});

    const [isLoading, {registerPromise}] = useLoading(false);
    const {Modal} = useModal();

    const [roles, updateRoles] = useState([])

    const inviteAdmin = (values, formikHelpers) => {
        formikHelpers.setSubmitting(true);
        registerPromise(adminsService.inviteNewAdmin(organisationId, values))
            .then(() => {
                toastService.success(`Invitation email to ${values.email} successfully sent`)
                onClose()
            })
            .catch((error) => {
                toastService.error(error.message);
            })
            .finally(() => {
                formikHelpers.setSubmitting(false);
                afterInvite()
            })
    }

    const editAdmin = (values, formikHelpers) => {
        formikHelpers.setSubmitting(true);
        delete values.id;
        delete values.email;
        registerPromise(adminsService.editAdminById(organisationId, admin.id, values))
            .then(() => {
                toastService.success(`The admin has been successfully saved`)
                onClose()
            })
            .catch((error) => {
                toastService.error(error.message);
            })
            .finally(() => {
                formikHelpers.setSubmitting(false);
                afterInvite()
            })
    }

    const getRolesList = () => {
        adminsService.getAdminsRoles(organisationId)
            .then(({data}) => {
                updateRoles(data?.map(({id, name}) => {
                    return {
                        id,
                        label: name,
                        value: name
                    }
                }))
            })
    }

    useEffect(() => {
        getRolesList()
    }, [])

    return(
        <Modal isOpen={isOpen} toggle={() => onClose()} size="md"
               className="practitioner-modal fontStyles" >
            <Modal.Header onClose={() => onClose()} className="font-weight-semibold text-dark">
                {`${isEdit ? "Edit" : "Invite"} admin`}
            </Modal.Header>
            <Formik
                initialValues={isEdit ? admin : initialValues}
                validationSchema={validationSchema}
                validateOnBlur
                onSubmit={(values, formikHelpers) => {
                    return isEdit ? editAdmin(values, formikHelpers) : inviteAdmin(values, formikHelpers)
                }}
                enableReinitialize
            >
                {({values, errors, handleSubmit, isSubmitting, setFieldValue}) => {
                    return (
                        <form
                            className={joinClassNames("form-horizontal", isSubmitting && "pointer-events-none")}
                            onSubmit={handleSubmit}
                        >
                            <Modal.Body>
                                <div className="d-flex flex-column gap-3">
                                    <FormikInput
                                        id="firstName"
                                        name="firstName"
                                        label="First name"
                                        containerClassName="relative w-100"
                                        placeholder="John"
                                        type="text"
                                        maxLength={MAX_NAME_LENGTH}
                                    />
                                    <FormikInput
                                        id="lastName"
                                        name="lastName"
                                        label="Last name"
                                        containerClassName="relative w-100"
                                        placeholder="Doe"
                                        type="text"
                                        maxLength={MAX_NAME_LENGTH}
                                    />
                                    <FormikInput
                                        type="email"
                                        name="email"
                                        label="Admin’s email"
                                        placeholder="admin@email.com"
                                        disabled={isEdit}
                                    />
                                    <FormikReactSelect
                                        setFieldValue={(name, item) => {
                                            setFieldValue(name, item.id);
                                        }}
                                        options={roles}
                                        name="roleId"
                                        className="role-custom-select"
                                        placeholder="Select role"
                                        label="Role"
                                        withError
                                        containerClassName="role-custom-select"
                                        valuePipe={(item) => item}
                                        value={roles.find(({ id }) => id === values.roleId)}
                                    />
                                </div>
                            </Modal.Body>
                            <ModalFooter>
                                <div className="d-flex justify-content-end gap-2">
                                    <Button
                                        color={BUTTON_COLORS.primaryOutline}
                                        type="button"
                                        onClick={onClose}
                                    >
                                        Cancel
                                    </Button>

                                    <Button
                                        color={BUTTON_COLORS.primary}
                                        type="submit"
                                        disabled={!!Object.keys(errors).length || isSubmitting}
                                        loading={isLoading}
                                    >
                                        {`${isEdit ? "Save" : "Send invite"}`}
                                    </Button>
                                </div>
                            </ModalFooter>
                        </form>
                    )
                }}
            </Formik>
        </Modal>
    )
}

export default InviteAdminModal